

import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, questionsActions } from "../../../_actions";
import moment from "moment";
import { CONST } from "../../../_config";

import * as XLSX from "xlsx";

import AssessmentReport from "../../Surveylink/Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../../Surveylink/Component/AssessmentSummary/AssessmentSummary";
import AssessmentManagerReport from "../../Surveylink/Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../../Surveylink/Component/AssessmentHiringReport/AssessmentHiringReport";

import Footer from "../Home/Component/Footer";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
// import Header from "../Home/Component/Header";

class AssessmentProductsNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      showMsg: false,
      showMsg2: false,
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      activeTab: 4,
      drowdown: true,
      viewCode: true,
      modaleOpen: false,
      formNameData: {
        id: "",
        name: "",
      },
      crrPackId: "",
      showReportModal: false,
      showSummaryReport: false,
      surveyLanguageCode: "",
      themeType: 2,
      crrEmpDetails: {
        emp_id: "",
        name: "",
      },
      selectedValue: "1",
      formUserData: {
        name: "",
        email: "",
        country: "",
        postcode: "",
        mobile: "",
        organisation: "",
      },
      showManagerReportModal: false,
      showHiringReport: false,
      crrCodeCopied: "",
      crrLicensee: ""
    };
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.ViewCode = this.ViewCode.bind(this);
    this.drowDown = this.drowDown.bind(this);
    this.ModalOpen = this.ModalOpen.bind(this);
  }

  handleClick() {
    this.setState({ showMsg: true });
    setTimeout(() => {
      this.setState({ showMsg: false });
    }, 3000);
  }

  handleClick2(value) {
    this.setState({ showMsg2: true, crrCodeCopied: value });
    setTimeout(() => {
      this.setState({ showMsg2: false, crrCodeCopied: "" });
    }, 3000);
  }

  CopyClick() {
    window.alert("DJKEOPIUJH : Assessment Code Copied!!");
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentCartCount());
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());

    this.props.dispatch(assessmentActions.getOrderBookList());
    window.scrollTo(0, 0);

  }

  ModalOpen = () => {
    this.setState({ modaleOpen: !this.state.modaleOpen });
  };
  ViewCode = () => {
    this.setState({ viewCode: !this.state.viewCode });
  };

  drowDown = () => {
    this.setState({ drowdown: !this.state.drowdown });
  };

  handleTabClick = (tabIndex, temp) => {
    this.setState({ activeTab: tabIndex, crrPackId: "", crrLicensee: "" }, () => {
      if (tabIndex === 5) {
        let data = {
          id: temp.id,
        };
        console.log("temp-1->", temp);
        this.setState({ crrPackId: temp.id, crrLicensee: temp.licensee });
        this.props.dispatch(assessmentActions.userAssessmentOrders(data));
        this.props.dispatch(
          assessmentActions.userAssessmentResponseAnalytics(data)
        );
      } else if (tabIndex === 2) {
        let { assessment } = this.props;
        let { userAssessmentUserProfileData } = assessment;
        let data = {
          name:
            userAssessmentUserProfileData && userAssessmentUserProfileData.name
              ? userAssessmentUserProfileData.name
              : "",
          email:
            userAssessmentUserProfileData && userAssessmentUserProfileData.email
              ? userAssessmentUserProfileData.email
              : "",
          country:
            userAssessmentUserProfileData &&
              userAssessmentUserProfileData.country
              ? userAssessmentUserProfileData.country
              : "",
          postcode:
            userAssessmentUserProfileData &&
              userAssessmentUserProfileData.postcode
              ? userAssessmentUserProfileData.postcode
              : "",
          mobile:
            userAssessmentUserProfileData &&
              userAssessmentUserProfileData.mobile
              ? userAssessmentUserProfileData.mobile
              : "",
          organisation:
            userAssessmentUserProfileData &&
              userAssessmentUserProfileData.organisation
              ? userAssessmentUserProfileData.organisation
              : "",
        };
        this.setState({ formUserData: data });
      } else {
        this.setState({ crrPackId: "" });
      }

      if (tabIndex === 2) {
        this.props.history.push(`/assessment/` + "profile-summary");
      } else if (tabIndex === 2) {
        this.props.history.push(`/assessment/` + "profile-summary");
      } else if (tabIndex === 3) {
        this.props.history.push(`/assessment/` + "my-orders");
      } else if (tabIndex === 4) {
        this.props.history.push(`/assessment/` + "assessment-code");
      }
    });
  };

  handleRedirect = () => {
    this.props.history.push('/assessment/contact-us');
  }
  // TabClick = (tabIndex) => {
  //   this.setState({ activeTab: tabIndex });
  // };

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.user.userAssessmentMyCartSuccess) {
      return {
        ...nextProps,
        showLogin: false,
      };
    }
    if (nextProps.user.getEmployeeStatusSucess) {
      return {
        ...nextProps,
        notFoundText: "Success!",
      };
    }
    if (nextProps.user.getEmployeeStatusFailed) {
      return {
        ...nextProps,
        notFoundText: "Employee not found!",
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    this.props.history.push(`/assessment/` + field);
  };

  onEditSingleName = (element, check) => {
    let { formNameData } = this.state;
    if (check) {
      formNameData = {
        id: element.id,
        name: element.name,
      };
    } else {
      formNameData = {
        id: "",
        name: "",
      };
    }
    this.setState({ showNameEdit: true, formNameData });
  };

  onSingleNameInput = (value, element) => {
    let { formNameData } = this.state;
    formNameData = {
      id: element.id,
      name: value,
    };
    this.setState({ formNameData });
  };

  onSingleNameSave = () => {
    let { formNameData, crrPackId } = this.state;
    let data = {
      id: formNameData.id,
      name: formNameData.name,
    };
    let temp = {
      id: crrPackId,
    };
    this.props.dispatch(
      assessmentActions.userAssessmentOrderNameUpdate(data, temp)
    );
    formNameData = {
      id: "",
      name: "",
    };
    this.setState({ showNameEdit: false });
  };

  viewReport = (ele) => {
    console.log("ele 1-->", ele);

    if (ele && ele.productId && ele.productId.code) {
      let code = ele.productId.code;

      if (code === "Top5TalentplusStrengths") {
        console.log("Top5TalentplusStrengths 1-->");
        this.handleSummaryReport(ele);
      } else if (code === "TalentPlusStrengths21") {
        console.log("TalentPlusStrengths21 1-->");
        this.handleReport(ele);
      } else if (code === "TalentplusManagerStrengths") {
        console.log("TalentplusManagerStrengths 1-->");
        this.handleManagerReport(ele);
      } else if (code === "TalentPlusHiringStrengths") {
        console.log("TalentPlusHiringStrengths 1-->");
        this.handleHiringReport(ele);
      }
    }

    let temp = {
      emp_id: ele.emp_id,
      name: ele.name,
    };
    this.setState({ crrEmpDetails: temp });
  };

  handleReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true,
    };
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showReportModal: true });
  };

  handleSummaryReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true,
    };
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showSummaryReport: true });
  };
  handleManagerReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true,
    };
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showManagerReportModal: true });
  };
  handleHiringReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true,
    };
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showHiringReportModal: true });
  };

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };

  closeManagerReportModal = () => {
    this.setState({ showManagerReportModal: false });
  };

  closeHiringReportModal = () => {
    this.setState({ showHiringReportModal: false });
  };

  handleLanguage = (item) => {
    console.log("item------------------->", item);
    if (item.shortName === "en") {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: "English",
        surveyLanguageRTL: false,
      });
    } else {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: item.name,
        surveyLanguageRTL: item.isRTL,
      });
    }
  };
  handleDropdownChange(event) {
    const activeTab = event.target.value;


    if (Number(activeTab) === 2) {
      this.props.history.push(`/assessment/` + "profile-summary");

    } else if (Number(activeTab) === 2) {
      this.props.history.push(`/assessment/` + "profile-summary");

    } else if (Number(activeTab) === 3) {
      this.props.history.push(`/assessment/` + "my-orders");

    } else if (Number(activeTab) === 4) {
      this.props.history.push(`/assessment/` + "assessment-code");
    }

    this.setState({
      activeTab: Number(activeTab)
    });

    console.log('activeTabactiveTabactiveTabactiveTabactiveTabactiveTabactiveTab', activeTab);
  }

  handleDownloadSample = () => {
    let binary_univers = [
      {
        name: "john",
      },
    ];

    //console.log('binary_univers: ', binary_univers)

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);

    // Create a new Workbook
    var wb = XLSX.utils.book_new();

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");

    // export your excel
    XLSX.writeFile(wb, "namefile.xlsx");
  };

  updateUserDetails = () => {
    let { formUserData } = this.state;
    let data = {
      name: formUserData && formUserData.name ? formUserData.name : "",
      email: formUserData && formUserData.email ? formUserData.email : "",
      country: formUserData && formUserData.country ? formUserData.country : "",
      postcode:
        formUserData && formUserData.postcode ? formUserData.postcode : "",
      mobile: formUserData && formUserData.mobile ? formUserData.mobile : "",
      organisation:
        formUserData && formUserData.organisation
          ? formUserData.organisation
          : "",
    };
    this.props.dispatch(assessmentActions.updateAssessmentUserProfile(data));
  };

  handleFormData = (value, name) => {
    let { formUserData } = this.state;
    formUserData[name] = value;
    this.setState({ formUserData });
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  render() {
    let { assessment, questions } = this.props;
    let {
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getTranslateElementAllData,
      getAssessmentCartCountData,
      loading
    } = questions;

    let {
      showManagerReportModal,
      showHiringReportModal,
      crrEmpDetails,
      showSummaryReport,
      showReportModal,
      surveyLanguageCode,
      crrLicensee
    } = this.state;
    let {
      userAssessmentUserProfileData,
      userAssessmentResponseAnalyticsData,
      getAssessmentPackagesShortListData,
    } = assessment;
    console.log("crrLicensee-->", crrLicensee);


    let createdAt =
      getAssessmentStatusData && getAssessmentStatusData.createdAt
        ? moment(new Date(parseInt(getAssessmentStatusData.createdAt)))
          .utcOffset("+05:30")
          .format("DD MMMM, YYYY")
        : "";

    const { activeTab } = this.state;


    function getValueRes(field) {
      return field &&
        userAssessmentResponseAnalyticsData &&
        userAssessmentResponseAnalyticsData[0] &&
        userAssessmentResponseAnalyticsData[0][field]
        ? userAssessmentResponseAnalyticsData[0][field]
        : 0;
    }


    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (
          getTranslateElementAllData &&
          getTranslateElementAllData.length > 0
        ) {
          let getIndex = getTranslateElementAllData.findIndex(
            (prev) => prev.name === name
          );
          if (getIndex !== -1) {
            sentence =
              getTranslateElementAllData &&
                getTranslateElementAllData[getIndex] &&
                getTranslateElementAllData[getIndex]["transl"] &&
                getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode]
                ? getTranslateElementAllData[getIndex]["transl"][
                surveyLanguageCode
                ]
                : "";
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log(
          "getTranslateElementAllData------------>",
          getTranslateElementAllData
        );

        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence =
          element &&
            element["details"] &&
            element["details"]["transl"] &&
            element["details"]["transl"][surveyLanguageCode] &&
            element["details"]["transl"][surveyLanguageCode][name]
            ? element["details"]["transl"][surveyLanguageCode][name]
            : "";
        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    function EditButtonFn(name, text) {
      return <>{GetTextByLanguage(name, text)}</>;
    }
    function EditDetailsFn(element, name, text) {
      return <>{GetDetailsByLanguage(element, name, text)}</>;
    }



    return (
      <div className="">
        <HeaderTransprent
          handleSignInPage={this.handleSignInPage}
          userDetails={userAssessmentUserProfileData}
          logout={this.logout}
          gotoPage={this.gotoPage}
          props2={this.props}
          cartCount={
            getAssessmentCartCountData ? getAssessmentCartCountData : 0
          }
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />

        <section className="flex flex-col w-full gap-10 px-4 mx-auto mb-10 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
          <div className="w-full py-10 space-y-4 md:py-20">

            <h1 className="md:text-3xl text-2xl font-medium text-[#3D405B] pb-4">
              My Account
            </h1>{" "}

            <div className="flex flex-row gap-6 space-x-4 overflow-x-auto border-b whitespace-nowrap">
              <div className="flex items-center space-x-2 text-[#3D405B] border-transparent border-b-2 pb-6 capitalize">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-smart-home" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"></path>
                  <path d="M16 15c-2.21 1.333 -5.792 1.333 -8 0"></path>
                </svg>
                <span>  Account Summary</span>
              </div>

              <div className="flex items-center space-x-2 text-[#3D405B] border-transparent  border-b-2 pb-6 capitalize">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-shopping-cart" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                  <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                  <path d="M17 17h-11v-14h-2"></path>
                  <path d="M6 5l14 1l-1 7h-13"></path>
                </svg>
                <span className="">  my orders</span>
              </div>

              <div className="flex items-center space-x-2 text-[#2196F3] border-[#2196F3]  border-b-2 pb-6 capitalize">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-clipboard-text" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>
                  <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                  <path d="M9 12h6"></path>
                  <path d="M9 16h6"></path>
                </svg>
                <span>  Assessment Codes</span>
              </div>
            </div>

            <div className="bg-[#2196F3]/10 p-6 border w-full space-y-4 rounded">
              <h1>Assessment Survey Link:</h1>

              <div className="flex flex-col gap-4 lg:flex-row">
                <div className="border bg-white w-full flex justify-between rounded text-[#3D405B] items-center ">
                  <p className="px-4 truncate ">
                    {CONST.SURVEY_ASSESSMENT}
                  </p>
                  <div onClick={() => {
                    this.handleClick();
                    navigator.clipboard.writeText(CONST.SURVEY_ASSESSMENT)
                  }} className="p-2 px-4 border-l
                        hover:text-[#4CAF50]    cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100
                        ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-copy"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="#2c3e50"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {" "}
                      <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                      />{" "}
                      <rect x="8" y="8" width="12" height="12" rx="2" />{" "}
                      <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                    </svg>

                  </div>
                </div>

                <button className="bg-[#2196F3] px-4 py-2 text-white rounded-sm flex justify-center  space-x-2 whitespace-nowrap ">
                  <span>Start Assessment  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-right-filled" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 2l.324 .005a10 10 0 1 1 -.648 0l.324 -.005zm.613 5.21a1 1 0 0 0 -1.32 1.497l2.291 2.293h-5.584l-.117 .007a1 1 0 0 0 .117 1.993h5.584l-2.291 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l4 -4l.073 -.082l.064 -.089l.062 -.113l.044 -.11l.03 -.112l.017 -.126l.003 -.075l-.007 -.118l-.029 -.148l-.035 -.105l-.054 -.113l-.071 -.111a1.008 1.008 0 0 0 -.097 -.112l-4 -4z" strokeWidth="0" fill="currentColor"></path>
                  </svg>
                </button>
              </div>

            </div>


            <div className="flex flex-col w-full gap-10 pt-4 lg:flex-row">
              <div className="w-full space-y-4 lg:w-80 ">
                <h1 className="text-xl font-medium" >Filters</h1>

                <div className="border">
                  <h1 className="px-4 py-2 text-lg font-medium border-b">Select an Item</h1>
                  <div className="w-full">
                    <div className="px-4 py-2 m-4 text-sm font-medium uppercase bg-gray-100 ">order no: #014545846596</div>

                    <div className="p-4 py-2 space-y-2 ">
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths 28</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-[#2196F3] px-2 rounded-sm py-1.5 text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-check-filled " width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" strokeWidth="0" fill="currentColor"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Manager Streng</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                    </div>

                  </div>
                  <div className="w-full">
                    <div className="px-4 py-2 m-4 text-sm font-medium uppercase bg-gray-100 ">order no: #014545846596</div>

                    <div className="p-4 py-2 space-y-2 ">
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths 28</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-[#2196F3] px-2 rounded-sm py-1.5 text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-check-filled " width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" strokeWidth="0" fill="currentColor"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Manager Streng</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                    </div>

                  </div>
                  <div className="w-full">
                    <div className="px-4 py-2 m-4 text-sm font-medium uppercase bg-gray-100 ">order no: #014545846596</div>

                    <div className="p-4 py-2 space-y-2 ">
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths 28</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-[#2196F3] px-2 rounded-sm py-1.5 text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-check-filled " width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" strokeWidth="0" fill="currentColor"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Manager Streng</span>
                      </div>
                      <div className="flex flex-row gap-2 items-center bg-transparent  px-2 rounded-sm py-1.5 text-[#3D405B]">
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle text-[#3D405B]/40" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        </svg>
                        <span className="text-sm ">TalentPlusStrengths  Hiring Strengths</span>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="flex-1 w-full space-y-4 ">

                <div className="flex flex-col w-full gap-4 p-4 border md:flex-row md:justify-between md:items-center ">
                  <div className=" cursor-pointer flex md:items-center items-start space-x-4  lg:w-[40%] w-full">
                    <div className="w-20 h-20 ">
                      <img src="/img/assessment/Rectangle.png" className="w-20 h-20 " />
                    </div>
                    <div className="text-[#3D405B] md:whitespace-nowrap flex-1 space-y-2 ">
                      <div>
                        <h1 className="w-56">Top 5 TalentPlusStrengths</h1>
                        <p className="text-[#3D405B]/70 text-sm font-medium capitalize">self Plan</p>
                      </div>
                      <div>
                        <div className="md:hidden flex space-x-4 text-[#3D405B]">
                          <p className="">Qty :</p>
                          <h1 className="font-medium ">1</h1>
                        </div>
                        <div className="md:hidden flex space-x-4 text-[#3D405B]">
                          <p className="">Order Date :</p>
                          <h1 className="font-medium ">27 April, 2023</h1>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="text-[#3D405B]  w-[30%]  text-center  lg:block hidden ">
                    <p className="text-[#3D405B]/70">Qty</p>
                    <h1 className="text-lg ">1</h1>
                  </div>

                  <div className="text-[#3D405B]   w-[30%]   lg:block hidden ">
                    <p className="text-[#3D405B]/70">Ordered Date</p>
                    <h1 className="text-lg ">25 May, 2023</h1>
                  </div>

                </div>

                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                  <div className="p-4 bg-[#2196F3]/10 rounded-md flex flex-row gap-4 items-center">
                    <div className="w-20 h-20 bg-[#2196F3]/10 rounded-full flex items-center justify-center ">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-user-share text-[#2196F3]" width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h3"></path>
                        <path d="M16 22l5 -5"></path>
                        <path d="M21 21.5v-4.5h-4.5"></path>
                      </svg>
                    </div>

                    <div>
                      <p className="text-sm text-[#3D405B]/70 capitalize">code Assigned</p>
                      <h1 className="text-2xl font-medium text-[#3D405B]">16</h1>
                    </div>
                  </div>
                  <div className="p-4 bg-[#4CAF50]/10 rounded-md flex flex-row gap-4 items-center">
                    <div className="w-20 h-20 bg-[#4CAF50]/10 rounded-full flex items-center justify-center ">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-user-share text-[#4CAF50]" width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h3"></path>
                        <path d="M16 22l5 -5"></path>
                        <path d="M21 21.5v-4.5h-4.5"></path>
                      </svg>
                    </div>

                    <div>
                      <p className="text-sm text-[#3D405B]/70 capitalize">Completed</p>
                      <h1 className="text-2xl font-medium text-[#3D405B]">6</h1>
                    </div>
                  </div>
                  <div className="p-4 bg-[#FFC107]/10 rounded-md flex flex-row gap-4 items-center">
                    <div className="w-20 h-20 bg-[#FFC107]/10 rounded-full flex items-center justify-center ">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-user-share text-[#FFC107]" width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h3"></path>
                        <path d="M16 22l5 -5"></path>
                        <path d="M21 21.5v-4.5h-4.5"></path>
                      </svg>
                    </div>

                    <div>
                      <p className="text-sm text-[#3D405B]/70 capitalize">Pending</p>
                      <h1 className="text-2xl font-medium text-[#3D405B]">20</h1>
                    </div>
                  </div>

                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center justify-between overflow-hidden text-sm bg-white border rounded-md "><span className="p-2 rounded-l-full material-symbols-outlined text-slate-600" style={{ fontSize: '1.4rem' }}>search</span><input type="search" name="search" className="w-full py-2 md:w-48 focus:outline-none placeholder:text-slate-600" placeholder="Search" /></div>

                  <button className=" bg-white p-2 px-4 rounded-md border text-[#3D405B] group  hover:text-[#2196f3] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2"><svg xmlns="http://www.w3.org/2000/svg" className="group-hover:text-[#2196f3] transition-all duration-150  text-[#3D405B] icon icon-tabler icon-tabler-file-x" width={24} height={24} viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /><path d="M10 12l4 4m0 -4l-4 4" /></svg><span>Download Excel</span></button>
                </div>

                <div className="overflow-x-auto whitespace-nowrap "><table className="w-full border rounded-md "><tbody><tr className="text-[#3D405B] bg-[#F9FAFB] w-[40%]"><th className="p-2 px-4 font-medium text-left">Name</th><th className="p-2 px-4 font-medium text-left w-[40%]">Assessment Code</th><th className="p-2 px-4 font-medium text-left w-[10%]">Status</th><th className="p-2 px-4 font-medium text-center w-[10%]">Reports</th></tr></tbody><tbody className="divide-y "><tr><td className="p-2 px-4 text-left"><div className="flex items-center justify-between space-x-4"><span>keshrirai</span></div></td><td className="px-4 py-2"><div className="flex items-center justify-between space-x-4"><span className="border-[1.8px] w-full text-center rounded border-spacing-4 border-separate border-dashed p-2 px-6 bg-[#4CAF50]/10 text-[#4CAF50]  border-[#4CAF50]">b9w6Yz6FLF</span><span className="border  text-[#3D405B]/70 hover:text-[#4CAF50] p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100 "><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-floppy " width={24} height={24} viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path stroke="none" d="M0 0h24v24H0z" fill="none" /><rect x={8} y={8} width={12} height={12} rx={2} /><path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" /></svg></span></div></td><td className="px-4 py-2"><span className="px-6 py-2 bg-[#FFC107] text-white text-sm rounded w-36">Pending</span></td><td className="px-4 py-2 text-center"><button className="border  text-[#3D405B]/70  p-2 rounded cursor-pointer  "><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-floppy " width={24} height={24} viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><rect x={9} y={3} width={6} height={4} rx={2} /><line x1={9} y1={12} x2="9.01" y2={12} /><line x1={13} y1={12} x2={15} y2={12} /><line x1={9} y1={16} x2="9.01" y2={16} /><line x1={13} y1={16} x2={15} y2={16} /></svg></button></td></tr></tbody></table></div>

                <div className="flex lg:flex-row flex-col justify-start items-center gap-6 text-[#3D405B] text-sm font-medium p-6 px-0  ">
                  <p className>Pages</p>
                  <div className="flex border divide-x rounded-md "><button className="p-4 py-2 text-[#3D405B]/50 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition">Previous</button><button className="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition text-[#2196f3] ">1</button><button className="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition ">2</button><button className="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition ">3</button><button className="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition ">4</button><button className="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition ">5</button><button className="p-4 py-2 text-[#2196F3] hover:bg-[#F9FAFB] hover:text-[#2196F3] transition">Next</button></div>
                  <p>1 of 26</p>
                </div>

              </div>

            </div>


          </div>
        </section>

        <section
          style={{
            backgroundImage: `url('/img/Home/book_a_demo_bg.webp')`,
          }}
          className=" bg-[#E3F2FD] xl:bg-contain bg-cover bg-no-repeat bg-center   "
        >
          <div className="px-4 py-20 mx-auto space-y-8 text-center md:w-4/6 md:px-0">
            <div className="space-y-4 ">
              <h1 className="xl:text-4xl text-3xl leading-[3rem] xl:leading-[4rem] font-semibold text-[#212121] text-center capitalize aos-init aos-animate">
                Ready to leap from feedback to action?
              </h1>
              <p className="text-xl font-semibold text-[#3D405B]">
                Invest in your people today. If not now, when?
              </p>
            </div>
            <button
              onClick={this.handleRedirect}
              data-aos="fade-up"
              // onClick={() => this.gotoPage("contact-us")}
              className="bg-[#212121] hover:bg-[#1976D2] hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black transition-all duration-150  text-white py-2.5 px-6 rounded uppercase cursor-pointer flex justify-center items-center w-56 mx-auto"
            >
              Book a Demo
            </button>
          </div>
        </section>

        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />

        {this.state.modaleOpen ? (
          <div className="fixed top-0 right-0 z-40 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
            <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
              <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                <h2 className="text-lg font-semibold md:text-xl test-gray-800 ">
                  Upload Team
                </h2>
                <div
                  onClick={() => this.ModalOpen()}
                  className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 "
                >
                  <svg
                    className="w-6 h-6 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z" />
                  </svg>
                </div>
              </div>
              <div className="m-4 space-y-8 md:m-8 ">
                <div className="p-4 space-y-2 text-sm border divide-y rounded-md text-[#3D405B]">
                  <h1 className="text-lg font-semibold text-[#3D405B] ">
                    {" "}
                    Guidelines for uploading the data
                  </h1>
                  <ol className="list-disc pl-6 space-y-1.5 py-4 text-[#3D405B] ">
                    <li className>
                      {" "}
                      Mandatory Column include emp_id and email as first column
                      &amp; second column should be in the file.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Your file columns/headers should not contain any special
                      characters – this includes characters that are not numbers
                      or the English alphabet.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Be careful not to include duplicates of the same row – no
                      two employees should have the same emp_id or email.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Date format must be same as DD-MM-YYYY
                    </li>
                    <li className="capitalize">
                      {" "}
                      See the sample data format for reference and prepare your
                      master data accordingly without any change in mandatory
                      column names
                    </li>
                    <li className="capitalize">
                      {" "}
                      Make sure your Excel sheet is not password protected.
                    </li>
                  </ol>
                </div>
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-4 xl:grid-cols-4 md:grid-cols-2">
                    <div className="flex items-start p-2 px-4 space-x-4 rounded shadow-sm cursor-pointer 2xl:items-center bg-sky-100 md:col-span-2">
                      <span className="p-2 text-blue-500 bg-white rounded-full shadow-sm material-symbols-outlined">
                        download
                      </span>
                      <div onClick={() => this.handleDownloadSample()}>
                        <h1 className="text-sm font-medium md:text-base text-[#3D405B] ">
                          Download sample date
                        </h1>
                        <p className="text-sm text-gray-500">
                          See the sample data format for reference
                        </p>
                      </div>
                    </div>
                    <input type="file" id="file" accept=".xlsx,.csv" hidden />
                    <label
                      htmlFor="file"
                      className="rounded shadow-sm cursor-pointer bg-sky-100 md:col-span-2"
                    >
                      <div className="flex items-start p-2 px-4 space-x-4 2xl:items-center ">
                        <span className="p-2 text-blue-500 bg-white rounded-full shadow-sm material-symbols-outlined">
                          upload
                        </span>
                        <div>
                          <h1 className="text-sm font-medium md:text-base text-[#3D405B] ">
                            Upload Master Data
                          </h1>
                          <p className="text-sm text-gray-500">
                            Upload master data as per the guidelines
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="hidden">
                    <button className=" border border-green-500 rounded-md px-6 py-1.5 text-xs text-green-500 focus:outline-none">
                      Sample CSV
                    </button>
                    <button className="ml-22 border border-blue-500 rounded-md px-6 py-1.5 text-xs text-blue-500 focus:outline-none">
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {showReportModal ? (
          <AssessmentReport
            closeReportModal={this.closeReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}
            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            loading={loading}
          />
        ) : null}

        {showSummaryReport ? (
          <AssessmentSummary
            closeReportModal={this.closeSummaryReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}
            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            loading={loading}
          />
        ) : null}

        {showManagerReportModal ? (
          <AssessmentManagerReport
            closeReportModal={this.closeManagerReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}
            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            loading={loading}

          />
        ) : null}

        {showHiringReportModal ? (
          <AssessmentHiringReport
            closeReportModal={this.closeHiringReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}
            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            loading={loading}

          />
        ) : null}



      </div>
    );
  }
}
AssessmentProductsNew.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(AssessmentProductsNew);
